import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

const RemoveConfirmationModal = ({
  isOpen,
  closeModal,
  titleId,
  messageId,
  handleRemoval,
  removeMessageId,
  storeName,
  buttonColor
}) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={closeModal}
      className="modal-dialog-centered"
    >
      <ModalHeader toggle={closeModal}>
        <FormattedMessage id={titleId} />
      </ModalHeader>
      <ModalBody>
        {storeName && (
          <div>
            <span>
              <FormattedMessage id="storeName" />: {storeName}
            </span>
          </div>
        )}
        <FormattedMessage id={messageId} />
      </ModalBody>
      <ModalFooter>
        <Button
          data-testid="removeConfirmationButton"
          color={buttonColor || "danger"}
          onClick={() => {
            handleRemoval();
            closeModal();
          }}
        >
          <FormattedMessage id={removeMessageId || 'remove'} />
        </Button>
        <Button color="secondary" onClick={closeModal}>
          <FormattedMessage id="cancel" />
        </Button>
      </ModalFooter>
    </Modal>
  );
};

RemoveConfirmationModal.propTypes = {
  isOpen: PropTypes.bool,
  closeModal: PropTypes.func,
  titleId: PropTypes.string,
  messageId: PropTypes.string,
  handleRemoval: PropTypes.func,
};

export default RemoveConfirmationModal;
